var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 190,
    height: 50,
    viewBox: "0 0 190 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Logo"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 190,
    height: 50
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Logo",
    clipPath: "url(#clip-Logo)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logo-2",
    "data-name": "Logo",
    style: {
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M14,.153C7.549-.816,1.235,2.92,0,8.592A5.525,5.525,0,0,1,6.451,4.857a5.042,5.042,0,0,1,4.529,5.811h0L5.764,36.816h0c7,1.107,13.725-3.044,14.96-9.27L23.743,12.6h0C24.979,6.655,20.587,1.121,14,.153Z",
    transform: "translate(43.095 13.005)",
    fill: "#f15a24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M13.45.153C7.137-.816,1.235,2.92,0,8.454v.138A5.028,5.028,0,0,1,5.764,5.134a4.6,4.6,0,0,1,4.117,5.119h0L4.666,36.4h0c7,1.107,13.725-3.044,14.96-9.27L22.646,12.19h0a.511.511,0,0,1,.137-.415C23.881,6.517,19.763,1.121,13.45.153Z",
    transform: "translate(20.861 13.143)",
    fill: "#f4d13d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M13.45.153C7.137-.816,1.235,2.92,0,8.454v.138A5.028,5.028,0,0,1,5.764,5.134a4.6,4.6,0,0,1,4.117,5.119h0L4.666,36.54H4.8L2.2,49.821h0c7,1.107,13.725-3.044,14.96-9.27l4.666-23.243a3.86,3.86,0,0,0,.137-1.245l.686-3.736h0a.511.511,0,0,1,.137-.415C23.881,6.379,19.763,1.121,13.45.153Z",
    transform: "translate(0 0)",
    fill: "#39b54a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M14,.153C7.549-.816,1.235,2.92,0,8.592A5.525,5.525,0,0,1,6.451,4.857a5.042,5.042,0,0,1,4.529,5.811h0L5.764,36.816h0c7,1.107,13.725-3.044,14.96-9.27L23.743,12.6h0C24.979,6.655,20.587,1.121,14,.153Z",
    transform: "translate(43.095 13.005)",
    fill: "#ff6226"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M13.45.153C7.137-.816,1.235,2.92,0,8.454v.138A5.028,5.028,0,0,1,5.764,5.134a4.6,4.6,0,0,1,4.117,5.119h0L4.666,36.4h0c7,1.107,13.725-3.044,14.96-9.27L22.646,12.19h0a.511.511,0,0,1,.137-.415C23.881,6.517,19.763,1.121,13.45.153Z",
    transform: "translate(20.861 13.143)",
    fill: "#ffce00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M13.45.153C7.137-.816,1.235,2.92,0,8.454v.138A5.028,5.028,0,0,1,5.764,5.134a4.6,4.6,0,0,1,4.117,5.119h0L4.666,36.54H4.8L2.2,49.821h0c7,1.107,13.725-3.044,14.96-9.27l4.666-23.243a3.86,3.86,0,0,0,.137-1.245l.686-3.736h0a.511.511,0,0,1,.137-.415C23.881,6.379,19.763,1.121,13.45.153Z",
    transform: "translate(0 0)",
    fill: "#2ecc28"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(81.57 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M23.554,12.008V6.277c0-4.23-1.76-6.277-5.415-6.277a6.27,6.27,0,0,0-4.873,2.183h0C12.454.682,10.829,0,8.8,0A6.27,6.27,0,0,0,3.926,2.183h0V2.32A4.923,4.923,0,0,0,0,.273H0V16.785H0a4.816,4.816,0,0,0,4.738-4.776V9.143h0V7.778c0-2.32.812-3.548,2.437-3.548,1.489,0,2.166,1.228,2.166,3.548V9.143h0v7.642a4.816,4.816,0,0,0,4.738-4.776V9.143h0V7.778c0-2.32.812-3.548,2.437-3.548,1.489,0,2.166,1.228,2.166,3.548V9.143h0v7.642A4.844,4.844,0,0,0,23.554,12.008Z",
    transform: "translate(0 5.185)",
    fill: "#272c48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M17.6,17.194V.409h0a5.1,5.1,0,0,0-3.655,1.638A8.585,8.585,0,0,0,8.528,0,8.527,8.527,0,0,0,0,8.6a8.554,8.554,0,0,0,13.943,6.687,4.675,4.675,0,0,0,3.655,1.91Zm-9.07-4.5a3.957,3.957,0,1,1,3.926-3.957A3.944,3.944,0,0,1,8.528,12.691Z",
    transform: "translate(25.991 4.776)",
    fill: "#272c48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M9.07,6.414A7.684,7.684,0,0,0,4.738,7.642V4.776A4.816,4.816,0,0,0,0,0V23.471A4.544,4.544,0,0,0,3.655,21.7,8.554,8.554,0,0,0,17.6,15.011,8.615,8.615,0,0,0,9.07,6.414Zm0,12.554A3.957,3.957,0,1,1,13,15.011,3.944,3.944,0,0,1,9.07,18.968Z",
    transform: "translate(0 25.245)",
    fill: "#272c48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M8.528,0A8.527,8.527,0,0,0,0,8.6a8.555,8.555,0,0,0,13.943,6.687A4.544,4.544,0,0,0,17.6,17.058V.409a5.094,5.094,0,0,0-3.655,1.638A8.585,8.585,0,0,0,8.528,0Zm0,12.554A3.957,3.957,0,1,1,12.454,8.6,3.944,3.944,0,0,1,8.528,12.554Z",
    transform: "translate(20.035 31.659)",
    fill: "#272c48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M8.528,0A8.527,8.527,0,0,0,0,8.6a8.555,8.555,0,0,0,13.943,6.687A4.543,4.543,0,0,0,17.6,17.058V.409a5.094,5.094,0,0,0-3.655,1.638A8.585,8.585,0,0,0,8.528,0Zm0,12.554A3.957,3.957,0,1,1,12.454,8.6,3.944,3.944,0,0,1,8.528,12.554Z",
    transform: "translate(56.178 31.659)",
    fill: "#272c48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M8.528,0A8.527,8.527,0,0,0,0,8.6a8.555,8.555,0,0,0,13.943,6.687A4.543,4.543,0,0,0,17.6,17.058V.409a5.094,5.094,0,0,0-3.655,1.638A8.585,8.585,0,0,0,8.528,0Zm0,12.554A3.957,3.957,0,1,1,12.454,8.6,4.034,4.034,0,0,1,8.528,12.554Z",
    transform: "translate(76.483 31.659)",
    fill: "#272c48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M0,10.371v.682H0A5.249,5.249,0,0,0,5.144,15.42h.948a.929.929,0,0,1,.948.955c0,.409-.135.955-.812.955H4.6a4.525,4.525,0,0,0-4.467,4.5H6.227a5.184,5.184,0,0,0,4.738-5.185,5.307,5.307,0,0,0-5.279-5.322H4.738a1.03,1.03,0,0,1-.677-.273V9.962c0-.409.135-.955.812-.955h9.34v7.642a4.816,4.816,0,0,0,4.738,4.776V9.552a4.557,4.557,0,0,0,4.061-4.5H18.681V4.776A4.816,4.816,0,0,0,13.943,0h0V5.049H4.738A5.184,5.184,0,0,0,0,10.235v.136Z",
    transform: "translate(46.567 0)",
    fill: "#272c48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M9.747,12.145H6.9L9.747,8.324h0L13.4,3.684h0a2.062,2.062,0,0,0,.541-1.5A2.147,2.147,0,0,0,11.777,0H0A4.583,4.583,0,0,0,4.6,4.64H7.445L4.6,8.461h0L1.083,13.1h0a2.062,2.062,0,0,0-.541,1.5,2.147,2.147,0,0,0,2.166,2.183H14.484A4.885,4.885,0,0,0,9.747,12.145Z",
    transform: "translate(40.611 31.932)",
    fill: "#272c48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M4.6.744,3.52,1.426A4.788,4.788,0,0,0,.135.062H0V16.846H.135A4.816,4.816,0,0,0,4.873,12.07V5.929l5.821-3.821A4.275,4.275,0,0,0,4.6.744Z",
    transform: "translate(97.736 32.006)",
    fill: "#272c48"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.671b324a8a9dadd3d24d6939ad903e09.svg";
export { ForwardRef as ReactComponent };